import { text_mod_67 } from "../text/Text.js";

export const module67 = {
  title: "Дієслова-синоніми",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_67,
    },
  ],
};
